import { z } from "zod";
import validations from "utils/validations";

export const datesAndConfigValidationSchema = z.object({
  closing_place: validations.requiredString("The address is required for the place of closing"),
});